<template>
    <div
        class="c-header-main__search"
        :class="{
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <AutocompleteForm
                :autocompleteUrl="autocompleteUrl"
                :isFormVisible="isFormVisible"
                :isOpen="isOpen"
                :inputPlaceholder="inputPlaceholder"
                :categoryIdValue.sync="categoryId" 
                v-model="keyword"
                @show-form="showForm"
                @hide-form="hideForm"
                @hide-results="hideResults"
                @reset-matches="resetMatches"
                @searched="setMatches"
            />
            <AutocompleteResults
                v-if="isOpen"
                :matches="matches"
                :keyword="keyword"
                :totals="totals"
                :isLoading="isLoading"
                :categoryId="categoryId"
                @hide-form="hideForm"
                @hide-results="hideResults"
            />
        </div>
    </div>
</template>

<script>
import { checkResolution } from 'Functions/helpers';
import RshopAutocomplete from "FrontendComponents/Autocomplete";
import { showHeaderOverlay, hideHeaderOverlay } from 'Functions/overlay';
import AutocompleteForm from 'VueComponents/AutocompleteForm';

export default {
    extends: RshopAutocomplete,
    components: {
        AutocompleteForm: AutocompleteForm,
        AutocompleteResults: () => import("./AutocompleteResults"),
    },
    created() {
        if (typeof rEvent.on === 'function') {
            rEvent.on('Autocomplete.showForm', (response) => {
                if (this.isFormVisible) {
                    this.hideForm();
                }
                else {
                    this.showForm();
                }
            });
        }
    },
    data() {
        return {
            categoryId: null,
            isFormVisible: false,
            isLoading: false
        };
    },
    beforeDestroy() {
        this.togglePageScrollLock(false);
    },
    computed: {
        inputPlaceholder() {
            return checkResolution('cxs') ? this.$t('Autocomplete.Header.placeholderMobile') : this.$t('Autocomplete.Header.placeholder')
        }
    },
    methods: {
        showForm() {
            this.isFormVisible = true

            if (this.matches.count) {
                this.showResults()
            }
        },
        hideForm() {
            this.isFormVisible = false
        },
        showResults() {
            this.isOpen = true
        },
        hideResults() {
            this.isOpen = false
        },
        resetMatches() {
            this.matches = {}
        },
        preventPageScroll($event) {
            if ($event.touches && $event.touches.length > 1) {
                return
            }

            if (this.$el.contains($event.target)) {
                return
            }

            $event.preventDefault()
        },
        togglePageScrollLock(locked) {
            const method = locked ? 'addEventListener' : 'removeEventListener'

            document[method]('touchmove', this.preventPageScroll, { passive: false })
            document[method]('wheel', this.preventPageScroll, { passive: false })
        },
        handleClickOutside($event) {
            if (!this.$el.contains($event.target) && (this.isOpen || this.isFormVisible) && !$event.target.closest('.js-trigger-search') && !$event.target.closest('.swal2-container')) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.rEvent.dispatch === 'function') {
                    window.rEvent.dispatch("Autocomplete.hide");
                }
            }
        },
    },
    watch: {
        isFormVisible(value) {
            document.querySelector('.js-header-bottom').classList.toggle('has-search-open', value)

            if (value) {
                showHeaderOverlay('autocomplete', true)
            } else {
                hideHeaderOverlay('autocomplete')
            }

            this.togglePageScrollLock(value)
        },
    }
};
</script>
